import { render, staticRenderFns } from "./NoAuth.vue?vue&type=template&id=645b5830&scoped=true&"
var script = {}
import style0 from "./NoAuth.vue?vue&type=style&index=0&id=645b5830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b5830",
  null
  
)

export default component.exports